import utils from '../libs/utils';
import axios from './axios';

// function axiosGet(url, params) {
//   return axios.get(`${url}?${utils.exchangeParams(params)}`);
// }
const MODULE_NAME = 'v1/erp-message-web';
export default {
  axios,
  messageList(params) {
    return axios.get(`${MODULE_NAME}/message/list?${utils.exchangeParams(params)}`);
  },
  messageCount(params) {
    return axios.get(`${MODULE_NAME}/message/prompt/count?${utils.exchangeParams(params)}`);
  },
  messageGroupList(params) {
    return axios.get(`${MODULE_NAME}/message/prompts?${utils.exchangeParams(params)}`);
  },
  messageDeal(params) {
    return axios.post(`${MODULE_NAME}/message/deal`, utils.exchangeParams(params));
  },
  messagePolling() {
    return axios.get(`${MODULE_NAME}/push/polling`);
  },
};
